import { Typography } from 'antd';
import React from 'react';

import { EXPIRED } from '@app/constants';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';
import { getStatusColor } from '@app/utils';

const { Text } = Typography;

export const TableTextComponent: React.FC<
  NTasksList.TableTextComponentProps
> = ({ text, isStrong, status }) => {
  return isStrong ? (
    <Text
      strong
      style={{
        color: `${getStatusColor(status === EXPIRED ? status : '')}`,
      }}
    >
      {text || ''}
    </Text>
  ) : (
    <Text
      style={{
        color: `${getStatusColor(status === EXPIRED ? status : '')}`,
      }}
    >
      {text || ''}
    </Text>
  );
};
